import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type TrafficSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalFilters";
import { isTrafficChangesModel } from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/type-guards/isTrafficChangesModel";
import { isTrafficMarketModel } from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/type-guards/isTrafficMarketModel";

export const isTrafficSignalFilters = (filters: SignalFilters): filters is TrafficSignalFilters => {
    if ("trafficChanges" in filters) {
        return isTrafficChangesModel(filters.trafficChanges);
    }

    if ("newMarkets" in filters) {
        return isTrafficMarketModel(filters.newMarkets);
    }

    return false;
};
